import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { SerieDocumentoInput } from 'sharedComponents/inputs/text'

import { KeyEventUtil } from 'utils'

const SerieDocumentoFormGroup = ({ iError, iTouched, fIsSubmitting, setFieldValue }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('input-infonota-numeroDocumento', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='SERIE' md={4} htmlFor='input-infonota-serieDocumento' alignRightAt='md' />
      <Col md={8}>
        <Field name='serieDocumento'>
          {({ field }) => (
            <SerieDocumentoInput
              {...field}
              id='input-infonota-serieDocumento'
              disabled={fIsSubmitting}
              isInvalid={iError && iTouched}
              onKeyDown={onKeyDown}
              setFieldValue={setFieldValue}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(SerieDocumentoFormGroup)
